import type * as React from 'react';
import type { FC } from 'react';

// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { BottomNavAction, BottomNavigation } from '@crehana/ui';
import { useUITheme } from '@crehana/web';

import type { RouteType } from '../types';

export interface MobileMenuProps {
  routes: RouteType[];
  currentIndex: number;
  onSelect: (value: string | number) => void;
  supportsDarkMode?: boolean;
}

const MobileMenu: FC<React.PropsWithChildren<MobileMenuProps>> = ({
  routes,
  currentIndex,
  onSelect,
  supportsDarkMode,
}) => {
  const { isDark } = useUITheme();
  const dark = supportsDarkMode && isDark;

  return (
    <BottomNavigation
      className="sm:hidden fixed bottom-0 left-0 z-5"
      value={currentIndex}
      onBottomNavActionChange={onSelect}
      dark={dark}
    >
      {routes.map(route => (
        <BottomNavAction
          key={`bottom-nav-${route.key}`}
          icon={{
            active: { component: route.activeIcon },
            inactive: { component: route.icon },
          }}
          dark={dark}
        />
      ))}
    </BottomNavigation>
  );
};

export default MobileMenu;
